import { useState } from "react";

const SortItem = ({fieldName, rows, setFilteredDataFromChild}) => {
    const [sortType, setSortType] = useState('default');
    const [sortField, setSortField] = useState(null);

    const onSortChange = (e, field, type) => {
        e.preventDefault();
        
        if(type !== 'default') {
            const sorted = [...rows].sort((a, b) => {
                if (field === 'item_code') {
                    setSortField('item_code');
                    var keyA = a.product.item_code, keyB = b.product.item_code;
                } else if (field === 'productprice') {
                    setSortField('productprice');
                    const productPriceA = parseFloat(a.product.product_price);
                    const productPriceB = parseFloat(b.product.product_price);
                    var keyA = productPriceA, keyB = productPriceB;
                } else if (field === 'quantity') {
                    setSortField('quantity');
                    var keyA = a.quantity, keyB = b.quantity;
                } else if (field === 'netvalue') {
                    setSortField('netvalue');
                    const productPriceA = parseFloat(a.product.product_price);
                    const productQuantityA = a.quantity;
                    const productTotalA = productQuantityA *  productPriceA;

                    const productPriceB = parseFloat(a.product.product_price);
                    const productQuantityB = a.quantity;
                    const productTotalB = productQuantityB *  productPriceB;

                    var keyA = productTotalA, keyB = productTotalB;
                } else if (field === 'vaT_Value') {
                    setSortField('vaT_Value');
                    const productPriceA = parseFloat(a.product.product_price);
                    const productPriceB = parseFloat(b.product.product_price);

                    const productVatA = (a.product.vat_percentage / 100);
                    const productQuantityA = a.quantity;
                    const productTotalA = productQuantityA *  productPriceA;
                    const productTotalVatA = productTotalA * productVatA;

                    const productVatB = (b.product.vat_percentage / 100);
                    const productQuantityB = b.quantity;
                    const productTotalB = productQuantityB *  productPriceB;
                    const productTotalVatB = productTotalB * productVatB;

                    var keyA = productTotalVatA, keyB = productTotalVatB;
                } else if (field === 'amount') {
                    setSortField('amount');
                    const productPriceA = parseFloat(a.product.product_price);
                    const productPriceB = parseFloat(b.product.product_price);

                    const productVatA = (a.product.vat_percentage / 100);
                    const productQuantityA = a.quantity;
                    const productTotalA = productQuantityA *  productPriceA;
                    const productTotalVatA = productTotalA * productVatA;

                    const productVatB = (b.product.vat_percentage / 100);
                    const productQuantityB = b.quantity;
                    const productTotalB = productQuantityB *  productPriceB;
                    const productTotalVatB = productTotalB * productVatB;

                    var keyA = (productTotalA+productTotalVatA), keyB = (productTotalB+productTotalVatB);
                } else if (field === 'item_code1') {
                    setSortField('item_code1');
                    var keyA = a.item_code, keyB = b.item_code;
                } else if (field === 'productprice1') {
                    setSortField('productprice1');
                    const productPriceA = parseFloat(a.UnitPrice);
                    const productPriceB = parseFloat(b.UnitPrice);
                    var keyA = productPriceA, keyB = productPriceB;
                } else if (field === 'quantity1') {
                    setSortField('quantity1');
                    var keyA = a.QTY1, keyB = b.QTY1;
                } else if (field === 'netvalue1') {
                    setSortField('netvalue1');
                    const productPriceA = parseFloat(a.UnitPrice);
                    const productQuantityA = a.QTY1;
                    const productTotalA = productQuantityA *  productPriceA;

                    const productPriceB = parseFloat(a.UnitPrice);
                    const productQuantityB = b.QTY1;
                    const productTotalB = productQuantityB *  productPriceB;

                    var keyA = productTotalA, keyB = productTotalB;
                } else if (field === 'vaT_Value1') {
                    setSortField('vaT_Value1');
                    const productPriceA = parseFloat(a.UnitPrice);
                    const productPriceB = parseFloat(b.UnitPrice);

                    const productVatA = (a.vat_percent / 100);
                    const productQuantityA = a.QTY1;
                    const productTotalA = productQuantityA *  productPriceA;
                    const productTotalVatA = productTotalA * productVatA;

                    const productVatB = (b.vat_percent / 100);
                    const productQuantityB = b.QTY1;
                    const productTotalB = productQuantityB *  productPriceB;
                    const productTotalVatB = productTotalB * productVatB;

                    var keyA = productTotalVatA, keyB = productTotalVatB;
                } else if (field === 'amount1') {
                    setSortField('amount1');
                    const productPriceA = parseFloat(a.UnitPrice);
                    const productPriceB = parseFloat(b.UnitPrice);

                    const productVatA = (a.vat_percent / 100);
                    const productQuantityA = a.QTY1;
                    const productTotalA = productQuantityA *  productPriceA;
                    const productTotalVatA = productTotalA * productVatA;

                    const productVatB = (b.vat_percent / 100);
                    const productQuantityB = b.QTY1;
                    const productTotalB = productQuantityB *  productPriceB;
                    const productTotalVatB = productTotalB * productVatB;

                    var keyA = (productTotalA+productTotalVatA), keyB = (productTotalB+productTotalVatB);
                }
    
                // Sort by String property ASCENDING
                if(type === 'asc') {
                    setSortType(type);
                    return keyA > keyB ? 1 : -1;
                }
                // Sort by String property DESCENDING
                if(type === 'desc') {
                    setSortType(type);
                    return keyA > keyB ? -1 : 1;
                }
            });
            setFilteredDataFromChild(sorted);
        } else {
            setSortType(type);
            setFilteredDataFromChild(rows);
        }
    }


    return (
        <>
            { sortType === 'default' ? <img onClick={(e) => onSortChange(e, fieldName, 'asc')} className="cursor-pointer" src="../../../../assets/icons/table/sort-arrow-default.svg" alt="sort-arrow-default" /> : null }
            { sortType === 'asc' && sortField === fieldName ? <img onClick={(e) => onSortChange(e, fieldName, 'desc')} className="cursor-pointer" src="../../../../assets/icons/table/sort-arrow-up.svg" alt="sort-arrow-up" /> : null }
            { sortType === 'desc' && sortField === fieldName ? <img onClick={(e) => onSortChange(e, fieldName, 'default')} className="cursor-pointer" src="../../../../assets/icons/table/sort-arrow-down.svg" alt="sort-arrow-down" /> : null }
        </>
    )
}

export default SortItem;